import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';
import { Observable } from 'rxjs';
import { ReportInformationResponse, ReportDetailsByJurisdiction } from '../models';
import { ListResponse } from '../interfaces';
import { REPORT_TYPE_ROUTES } from 'src/app/v2/constants';
@Injectable()
export class ComplianceCentralService extends BaseService<any> {

  reportInformationPath: string;
  reportDetailsPath: string;

  constructor(
    protected http: HttpClient,
    protected config: AppConfig,
  ) {
    super(http, config);
  }

  setReportResourcePaths(reportType) {
    this.reportInformationPath = REPORT_TYPE_ROUTES[reportType].reportInformationPath;
    this.reportDetailsPath = REPORT_TYPE_ROUTES[reportType].reportDetailsPath;
  }

  getReportInformation(containerId: number): Observable<ListResponse<ReportInformationResponse>> {
    return this.http.get<any>(`${this.getResourceUrl()}/containers/${containerId}${this.reportInformationPath}`);
  }

  getReportDetailsByJurisdiction(containerId: number, domicileId: number): Observable<ListResponse<ReportDetailsByJurisdiction>> {
    return this.http.get<any>(`${this.getResourceUrl()}/containers/${containerId}/domiciles/${domicileId}${this.reportDetailsPath}`
    );
  }

  getOecdReportDetails(containerId: number): Observable<ListResponse<ReportDetailsByJurisdiction>> {
    return this.http.get<any>(`${this.getResourceUrl()}/containers/${containerId}/oecd-master-file-report-details`);
  }

  getAllCounters(containerId: number): Observable<any> {
    return this.http.get<any>(`${this.getResourceUrl()}/containers/${containerId}/counters`);
  }

  protected getResourceUrl() {
    return `${this.config.getComplianceCentralApiUrl()}/v1`;
  }

}
